// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_fi-0";